import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";

@Component({
  selector: "app-menu-list",
  templateUrl: "./menu-list.component.html",
  styleUrls: ["./menu-list.component.scss"],
})
export class MenuListComponent {
  @Input() data;
  @Input() searchedValue = "";
  @Input() isLoading: boolean = false;
  @Input() selectedMenuId;
  @Output() onListClick: EventEmitter<any> = new EventEmitter();

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  ngOnChanges(changes) {
    if (
      changes.selectedMenuId &&
      changes.selectedMenuId.currentValue !==
        changes.selectedMenuId.previousValue
    ) {
      if (this.data) {
        this.data.forEach((element) => {
          element.selected = element.id === this.selectedMenuId;
        });
      }
    }
  }

  handleListClick(id, item, event) {
    const output = { id, item, event };
    this.onListClick.emit(output);
  }
}
